function init() {
	window.addEventListener('click', (e) => {
		const showBtn = e.target.closest('.js-show-more');

		if (showBtn) {
			const showContent = document.querySelector('.js-show-more-content');

			showBtn.classList.add('is-hidden');

			showContent.classList.remove('is-hidden');
			showContent.classList.add('is-visible');
		}
	});
}

export default {
	init,
};
